export const KEY_INITIATIVE_FORM_KEY = 'KEY_INITIATIVE_FORM'
export const PARENT_KEY_INITIATIVE_FORM_KEY = 'PARENT_KEY_INITIATIVE_FORM'

export const INITIATIVES_EDITOR_TYPE_LEGACY = 1
export const INITIATIVES_EDITOR_TYPE_STEPS = 2
export const INITIATIVES_EDITOR_TYPES: number[] = [
  INITIATIVES_EDITOR_TYPE_LEGACY,
  INITIATIVES_EDITOR_TYPE_STEPS,
]

export const PRACTICE_DEVELOPMENT = 'Practice Development'

export type TProgressViewItem = {
  key: string
  order: number
}

export const PROGRESS_VIEW_KEY = 'jbp-key-initiatives-progress-view'
export const PROGRESS_VIEW_LABEL_SUFFIX = '-label'
export const PROGRESS_VIEW_DESC_SUFFIX = '-desc'
export const PROGRESS_VIEW_ITEMS: TProgressViewItem[] = [
  {
    key: `${PROGRESS_VIEW_KEY}-commitment`,
    order: 0,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-jointoffer`,
    order: 1,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-capabilities`,
    order: 2,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-delivery`,
    order: 3,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-pipeline`,
    order: 4,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-referencecases`,
    order: 5,
  },
]
